import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { SettingsService } from '@services/settings/settings.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import * as moment from 'moment';

type SendMethod = 'days' | 'specific';

import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';

@Component({
  selector: 'app-sr-send-date',
  templateUrl: './sr-send-date.component.html',
  styleUrls: ['./sr-send-date.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule, BsDatepickerModule]
})
export class SrSendDateComponent implements OnInit {
    protected readonly settingsService = inject(SettingsService);
  @Input() sendDate!: string;
  @Output() update: EventEmitter<string> = new EventEmitter<string>();
  readonly defaultSendDate: number;
  readonly defaultDateFormat = 'DD-MM-YYYY';
  readonly defaultConfig: Partial<BsDatepickerConfig> = {
    selectFromOtherMonth: true,
    isAnimated: true,
    minDate: moment().toDate()
  };
  date = moment().toDate();
  sendMethod!: SendMethod;

  constructor(
) {
    this.defaultSendDate = this.settingsService.settings.sendDate;
  }

  ngOnInit() {
    if (this.sendDate && !isNaN(Number((this.sendDate)))) {
      this.sendMethod = 'days';
    } else {
      this.sendMethod = 'specific';
    }
  }

  updateDate(event: Date) {
    this.sendDate = moment(event).format(this.defaultDateFormat);
  }

  changeSendMethod(sendMethod: SendMethod) {
    this.sendMethod = sendMethod;
    if ('days' === sendMethod) {
      this.sendDate = String(this.defaultSendDate);
    } else {
      this.sendDate = moment(this.date).format(this.defaultDateFormat);
    }

    this.update.emit(this.sendDate);
  }
}
